/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the video's URL into the box above and choose a resolution. Click Download to save the image, or Copy URL to copy the direct link.`)
};

const es_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega la URL del video en el cuadro de arriba y elige una resolución. Haz clic en Descargar para guardar la imagen, o en Copiar URL para copiar el enlace directo.`)
};

const de_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge die URL des Videos in das Feld oben ein und wähle eine Auflösung. Klicke auf Herunterladen, um das Bild zu speichern, oder auf URL kopieren, um den direkten Link zu kopieren.`)
};

const nl_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak de URL van de video in het vak hierboven en kies een resolutie. Klik op Downloaden om de afbeelding op te slaan, of op URL kopiëren om de directe link te kopiëren.`)
};

const fr_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez l’URL de la vidéo dans le champ ci-dessus et choisissez une résolution. Cliquez sur Télécharger pour enregistrer l’image, ou sur Copier l’URL pour copier le lien direct.`)
};

const it_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla l'URL del video nel campo qui sopra e scegli una risoluzione. Clicca su Scarica per salvare l'immagine, oppure su Copia URL per copiare il link diretto.`)
};

const pt_br2_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole a URL do vídeo na caixa acima e escolha uma resolução. Clique em Baixar para salvar a imagem, ou em Copiar URL para copiar o link direto.`)
};

const pt_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o URL do vídeo na caixa acima e escolha uma resolução. Clique em Descarregar para guardar a imagem, ou em Copiar URL para copiar o link direto.`)
};

const ja_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上のボックスに動画のURLを貼り付け、解像度を選択します。「ダウンロード」をクリックすると画像を保存でき、「URLをコピー」をクリックすると直接リンクをコピーできます。`)
};

const zh_yt_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将视频链接粘贴到上方输入框中并选择分辨率。点击下载保存图片，或点击复制链接获取直接链接。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq1_a", locale)
	if (locale === "en") return en_yt_hub_faq1_a(inputs)
	if (locale === "es") return es_yt_hub_faq1_a(inputs)
	if (locale === "de") return de_yt_hub_faq1_a(inputs)
	if (locale === "nl") return nl_yt_hub_faq1_a(inputs)
	if (locale === "fr") return fr_yt_hub_faq1_a(inputs)
	if (locale === "it") return it_yt_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq1_a(inputs)
	if (locale === "pt") return pt_yt_hub_faq1_a(inputs)
	if (locale === "ja") return ja_yt_hub_faq1_a(inputs)
	return zh_yt_hub_faq1_a(inputs)
};